import styled from 'styled-components'
import { colors } from 'app/theme/colors'
import { breakpoint } from 'app/theme/tokens'

export const Container = styled.div`
  .header {
    font-size: 2rem;
    color: ${colors.textPrimary};
    font-weight: 600;
    font-family: 'Avenir';
  }
  .arrival {
    max-height: 2.5rem;
    width: 200px;
    font-family: 'Avenir';
  }
  .present {
    color: ${colors.ohTeal};
  }
  .absent {
    color: ${colors.ohRed};
  }
  .bold {
    font-weight: 600;
  }
  .topHeader {
    overflow-x: hidden;
  }
  .teacherDetails {
    width: 200px;
  }

  /* Mobile (<600px): the MUI Table this component renders has
     sx={{ width: 'max-content' }} + fixed 200px inner widths, which
     spills out of the bottom-sheet slider on a phone — the Attendance
     and Arrival Status columns get clipped at the right edge. Flatten
     it to a vertical label/value stack like the responsive table in
     history.css. */
  ${breakpoint.down('tablet')} {
    .header {
      font-size: 16px;
      padding: 0;
    }
    .topHeader,
    .topHeader table,
    .topHeader thead,
    .topHeader tbody,
    .topHeader tr {
      display: block;
      width: 100%;
    }
    .topHeader caption {
      display: block;
      padding: 8px 0;
      font-size: 13px;
    }
    .topHeader thead {
      /* Column headers are noise once each cell labels itself below. */
      display: none;
    }
    .topHeader tr {
      padding: 4px 0;
    }
    .topHeader td,
    .MuiTableCell-root {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 4px;
      width: 100% !important;
      padding: 8px 0 !important;
      border-bottom: 1px solid rgba(0, 0, 0, 0.06);
      box-sizing: border-box;
    }
    .topHeader tr:last-child td:last-child,
    .topHeader tr td:last-child {
      border-bottom: none;
    }
    /* Surface the column name above each value so users know what they're
       looking at without the hidden thead. */
    .topHeader td:nth-child(1)::before {
      content: 'Teacher';
    }
    .topHeader td:nth-child(2)::before {
      content: 'Attendance';
    }
    .topHeader td:nth-child(3)::before {
      content: 'Arrival status';
    }
    .topHeader td::before {
      font-size: 11px;
      font-weight: 600;
      color: #888;
      text-transform: uppercase;
      letter-spacing: 0.04em;
    }
    /* Free up the constrained 200px widths so the field can fill the row. */
    .arrival,
    .teacherDetails {
      width: 100%;
      max-width: 100%;
    }
    .arrival {
      max-height: none;
    }
    /* Kill the max-content table sizing so the table can wrap to the
       sheet width. */
    table {
      width: 100% !important;
      max-width: 100% !important;
    }
  }
`
